import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { additionalValue } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { galleryListQueries } from '@/services/galleryManagement/galleryManagement.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useGalleryList = () => {
  const search = useSearch({
    from: '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/',
  });
  const params = useParams({
    from: '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery',
  });

  const { page, fetch, q } = search;

  const { data, isFetched, isLoading } = useQuery({
    ...galleryListQueries.list({
      agentId: params['clubid'] || '',
      hostId: params['host-gallery'] || '',
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], search.sort),
    }),
  });
  return {
    getGalleryList: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
    commonHostId: (data?.meta?.additionalValue || '') as additionalValue,
    isFetched,
  };
};
